import React, { useState, useCallback, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { SIDENAV_KEYS, MENU_SIDEBAR_KEYS } from '../../utils/translation-constants'
import { Formik, Field, Form } from 'formik'
import Loading from 'custom/assets/loaders/Loading'
import InputError from '../../components/InputError/InputError'
import { LinkAccountSchema } from '../../schemas/others/linkaccount'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import LinkAccountService from '../../services/linkaccount.service'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import { useDispatch } from 'react-redux'
import { setAccRefresh } from '../../actions'
import NeoInput from '../../components/NeoInput/NeoInput'
import config from '../../api/constants'
import env from 'custom/config/environment'

function LinkAccount() {
  const [stage, setStage] = useState(1)
  const [message, setMessage] = useState('')
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [randomKey, setRandomKey] = useState('')
  const [otp, setOtp] = useState('')
  const dispatch = useDispatch()

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderForm()
      // case 2:
      //     return renderConfirmation()
      case 2:
        return (
          <NeoOTP otp={otp} setOTP={setOtp} onSubmit={confirmLinkAccountForm} loading={loading} />
        )
      case 3:
        return <NeoSuccess message={message} linkPath='/dashboard' />
      default:
        return renderLoading()
    }
  }

  const confirmLinkAccountForm = useCallback(
    async (data = {}) => {
      try {
        setLoading(true)
        const response = await LinkAccountService.linkAccountConfirm({
          srcAccount: formValues?.accountNo || data?.accountNo,
          otp: otp || '0000',
        })
        setMessage(response.message)
        setLoading(false)
        dispatch(setAccRefresh(true))
        setStage(3)
      } catch (err) {
        setLoading(false)
      }
    },
    [otp, randomKey, formValues],
  )

  const verifyLinkAccountForm = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setSubmitting(true)
        setFormValues(data)
        const response = await LinkAccountService.linkAccountVerify({
          srcAccount: data.accountNo,
        })
        if (response.randomKeyEnable) {
          setRandomKey(response.randomKey)
        } else {
          setRandomKey('')
        }
        if (response.otpEnable) {
          setStage(2)
        } else {
          await confirmLinkAccountForm(data)
        }
        setSubmitting(false)
        setLoading(false)
      } catch (err) {
        setSubmitting(false)
      }
    },
    [confirmLinkAccountForm],
  )

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    if (loading) {
      return (
        <div className='justify-content-center d-flex align-items-center'>
          <Loading />
        </div>
      )
    }

    return (
      <div>
        <Formik
          initialValues={{
            accountNo: '',
          }}
          validationSchema={LinkAccountSchema}
          onSubmit={verifyLinkAccountForm}>
          {({ isSubmitting, errors, touched, setFieldValue }) => (
            <Form>
              <div className='form-group'>
                <NeoInput
                  tabIndex='1'
                  text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.LINK_ACCOUNT_NO)}
                  onChange={(value) => {
                    setFieldValue('accountNo', value?.value)
                  }}
                  // mode='password'
                  mode='onlyNumber'
                  name='accountNo'
                  maxLength={env.ACC_NO_LENGTH}
                />
                <InputError text={errors.accountNo} touched={touched.accountNo} />
              </div>

              <div className='mt-5'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='2'
                    type='submit'
                    disabled={isSubmitting}
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.LINK_ACCOUNT)}
                    mode='newDesign'
                  />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='LINK_ACCOUNT'
      keyPath={'LINK_ACCOUNT'}
      showEmptySpace={true}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.LINK_ACCOUNT)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}

export default LinkAccount
